// react
import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// hooks
import useNotifications from '../../hooks/useNotifications';
// styles
import { Button, Container, Form, Row, Col } from 'react-bootstrap';
import styles from './ChangePassword.module.css';
// context
import { AccountContext } from '../../GlobalContex';

const ChangePassword = () => {
  const { t } = useTranslation();
  const notification = useNotifications();
  const [validState, setValidState] = useState(true);
  const [oldPassValidState, setOldPassValidState] = useState(true);
  const [newPassword, setNewPassword] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const navigate = useNavigate();

  const { changepassword } = useContext(AccountContext);

  const submitHandler = async e => {
    e.preventDefault();
    if (!oldPassword || !newPassword || !confirmPassword) return;
    try {
      await changepassword(newPassword, oldPassword);
      notification.success(
        t('Your password was successfully changed. You can now use it to log in.')
      );
      setTimeout(() => {
        navigate('/register');
      }, 5000);
    } catch (err) {
      if (err.message === 'Incorrect old password') {
        setOldPassValidState(false);
        return;
      }
      notification.error(err);
    }
  };
  useEffect(() => {
    if (newPassword && confirmPassword) {
      if (newPassword !== confirmPassword) {
        setValidState(false);
      } else {
        setValidState(true);
      }
    }
  }, [newPassword, confirmPassword]);

  return (
    <div className={styles.login__screen + ' bootstrap-app-styles h-100'}>
      <div className={'d-flex justify-content-center align-items-center h-100'}>
        <Container>
          <Row className="justify-content-center">
            <Col xs={12}>
              <Form onSubmit={e => submitHandler(e)}>
                <h5 className="text-center mb-3">{t('Change Password')}</h5>

                <Form.Group className={'mb-3'}>
                  <Form.Control
                    type="password"
                    value={oldPassword}
                    onChange={e => {
                      setOldPassword(e.target.value);
                      setOldPassValidState(true);
                    }}
                    placeholder={t('Old Password')}
                    className={oldPassValidState ? '' : 'is-invalid'}
                  />
                  {oldPassValidState}
                  {!oldPassValidState && (
                    <div className="invalid-feedback">{t('Incorrect old password')}</div>
                  )}
                </Form.Group>

                <Form.Group className={'mb-3'}>
                  <Form.Control
                    type="password"
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                    placeholder={t('New Password')}
                  />
                </Form.Group>

                <Form.Group className={'mb-3'}>
                  <Form.Control
                    type="password"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    placeholder={t('Confirm New Password')}
                    className={validState ? '' : 'is-invalid'}
                  />
                  {!validState && (
                    <div className="invalid-feedback">
                      {t("The two password fields didn't match.")}
                    </div>
                  )}
                </Form.Group>

                <Button
                  type="submit"
                  className="w-100"
                  disabled={!validState || !oldPassValidState}>
                  {t('Change Password')}
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default ChangePassword;
